var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-wrp"},[_c('FormList',{attrs:{"list":_vm.formList,"data":_vm.addressInfo,"onChange":_vm.onInputChange}}),_c('ButtonRow',{attrs:{"firstText":this.$route.params.type === 'edit' ? '删 除' : '返 回',"firstClick":this.$route.params.type === 'edit' ? _vm.deleteAddress : _vm.goBack,"secondClick":_vm.confirm,"bottom":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }